'use strict';

class Klarna {
    // Save ScalaPay widget element, waits for script to be loaded
    loadWidget () {
        if (document.getElementsByTagName('klarna-placement') && document.getElementsByTagName('klarna-placement')[0]) {
            $('body').on('product:afterAttributeSelect', function (e, response) {
                if (response.data.product.price.sales) {
                    document.getElementsByTagName('klarna-placement')[0].setAttribute('data-purchase-amount', Math.round(response.data.product.price.sales.value * 100));
                    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
                }
            });
        }
    }

    // Load Klarna widget and analytics observer
    loadKlarnaWidgetAndObservers () {
        if ($('.page').data('action') === 'Product-Show' || $('.page').data('action') === 'Cart-Show') {
            var _self = this;
            _self.loadWidget();

            var checkWidget = setInterval(function () {
                let klarnaPayWidget = $('klarna-placement');

                if (klarnaPayWidget.length) {
                    clearInterval(checkWidget);
                    _self.prepareObservers();
                }
            }, 2000);
        }
    }

    // Observe analytics event
    prepareObservers () {
        if (!$('klarna-placement div').length) {
            return;
        }
        $($('klarna-placement div')[0].shadowRoot).find('button.link').on('click', function () {
            $('body').trigger('klarnaPay:openModal');
        });
    }
}

const klarna = new Klarna();
export default klarna;
